import React from 'react';
import { useGetRequestSelectOptions } from "../../../../hooks/request/options/useGetRequestSelectOptions";
import { BoundSelect } from "./BoundSelect";

type BoundDataDrivenSelectProps<T> =  {
  requestUrl: string;
  queryParams?: Record<string, unknown>;
  shouldAbort?: boolean;
  name: string;
  value?: string | number | null;
  label: string;
  onChange: (newQuery: T) => void;
}

const BoundDataDrivenSelect = <T,>({
  requestUrl,
  queryParams,
  shouldAbort,
  name,
  value = '',
  label,
  onChange
}: BoundDataDrivenSelectProps<T>) => {

  const { options } = useGetRequestSelectOptions({ requestUrl, queryParams, shouldAbort });

  return (<BoundSelect<T>
    options={options}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
  )
};


export { BoundDataDrivenSelect };